import { render } from "./NutricionPlatoSlot.vue?vue&type=template&id=767aac02&scoped=true"
import script from "./NutricionPlatoSlot.vue?vue&type=script&lang=js"
export * from "./NutricionPlatoSlot.vue?vue&type=script&lang=js"

import "./NutricionPlatoSlot.vue?vue&type=style&index=0&id=767aac02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767aac02"]])

export default __exports__